import { render, staticRenderFns } from "./FooterAd.vue?vue&type=template&id=42566a09&"
import script from "./FooterAd.vue?vue&type=script&lang=js&"
export * from "./FooterAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports